import { render, staticRenderFns } from "./SimilarImageReviewDecisionPanel.vue?vue&type=template&id=4bf38e76&scoped=true"
import script from "./SimilarImageReviewDecisionPanel.vue?vue&type=script&lang=js"
export * from "./SimilarImageReviewDecisionPanel.vue?vue&type=script&lang=js"
import style0 from "./SimilarImageReviewDecisionPanel.vue?vue&type=style&index=0&id=4bf38e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf38e76",
  null
  
)

export default component.exports